/* eslint-disable react/jsx-no-target-blank */
import { useContext } from "react";
import { AuthContext } from "src/context/authContext";
import { FooterContext } from "src/context/footerContext";


const Footer = () => {
  const { isManufacturer } = useContext(AuthContext);
  const { isAccordianShown, changeAccordianVisibility } = useContext(FooterContext);


  return (
      <>
          {!isManufacturer && (
              <footer className="footer-policy">
                  <div className="accordion">
                      <div className="accordion-header">
                          <button onClick={changeAccordianVisibility}
                                  className="accordion-button text-uppercase" type="button"
                                  data-bs-toggle="collapse" data-bs-target="#collapseOne">
                              PLEASE SEE IMPORTANT SAFETY INFORMATION AND FULL PRESCRIBING INFORMATION
                              {isAccordianShown ? (
                                  <i className="bi bi-chevron-down ps-1"></i>
                              ) : (
                                  <i className="bi bi-chevron-up ps-1"></i>
                              )}
                          </button>
                      </div>
                      <div className={`accordion-collapse collapse ${isAccordianShown ? 'show' : ''}`} style={{backgroundColor:"#EEF4FF"}}>
                          <div className="container pt-3">
                              <h3 className="mb-4">INDICATION AND IMPORTANT SAFETY INFORMATION</h3>
                              <h4 className="text-primary fw-medium">Indication</h4>
                              <p className="text-black">
                                  ZILRETTA<sup>&reg;</sup> (triamcinolone acetonide extended-release injectable suspension) is an
                                  extended-release synthetic corticosteroid indicated as an intra-articular injection for
                                  the management of osteoarthritis pain of the knee.
                              </p>
                              <p className="text-black">
                                  <strong>Limitation of Use:</strong>  The efficacy and safety of repeat administration
                                  of ZILRETTA have not been demonstrated.
                              </p>

                              <h3 className="text-primary fw-medium">Important Safety Information</h3>

                              <h4 className="text-primary fw-medium">Contraindication</h4>
                              <p className="text-black">
                                  ZILRETTA is contraindicated in patients who are hypersensitive to triamcinolone
                                  acetonide, corticosteroids, or any components of the product.
                              </p>

                              <h4 className="text-primary fw-medium">Warnings and Precautions</h4>
                              <ul className="text-black">
                                  <li>
                                      <strong>Intra-articular Use Only:</strong> ZILRETTA has not been evaluated and should
                                      not be administered by epidural, intrathecal, intravenous, intraocular,
                                      intramuscular, intradermal, or subcutaneous routes. Serious events have been
                                      reported with epidural and intrathecal administration of
                                      corticosteroids and none are approved for this use. ZILRETTA should not be
                                      considered safe for epidural or intrathecal administration.
                                  </li>
                                  <li>
                                      <strong>Hypersensitivity Reactions:</strong> Rare instances of anaphylaxis, including
                                      serious cases, have occurred in patients with hypersensitivity to
                                      corticosteroids.
                                  </li>
                                  <li>
                                      <strong>Joint Infection and Damage:</strong> A marked increase in pain accompanied
                                      by local swelling, restriction of joint motion, fever, and malaise are
                                      suggestive of septic arthritis. Examine joint fluid to exclude a septic process.
                                      If diagnosis is confirmed, institute appropriate antimicrobial therapy.
                                      Avoid injecting corticosteroids into a previously infected or unstable joint.
                                      Intra-articular administration may result in damage to joint tissues.
                                  </li>
                                  <li>
                                      <strong>Increased Risk of Infections:</strong> Infection with any pathogen in any
                                      location of the body may be associated with corticosteroid use. Corticosteroids
                                      may increase the susceptibility to new infection and decrease resistance and the
                                      ability to localize infection.
                                  </li>
                                  <li>
                                      <strong>Alterations in Endocrine Function:</strong> Corticosteroids can produce
                                      reversible hypothalamic-pituitary-adrenal axis suppression, with potential for
                                      adrenal insufficiency after withdrawal of treatment, which may persist for months.
                                      In situations of stress during that period, institute corticosteroid
                                      replacement therapy.
                                  </li>
                                  <li>
                                      <strong>Cardiovascular and Renal Effects:</strong> Corticosteroids can cause blood
                                      pressure elevation, salt and water retention, and increased potassium
                                      excretion. Monitor patients with congestive heart failure, hypertension, and renal
                                      insufficiency for edema, weight gain, and electrolyte imbalance.
                                      Dietary salt restriction and potassium supplementation may be needed.
                                  </li>
                                  <li>
                                      <strong>Increased Intraocular Pressure:</strong> Corticosteroid use may be associated
                                      with increased intraocular pressure. Monitor patients with elevated
                                      intraocular pressure for potential treatment adjustment.
                                  </li>
                                  <li>
                                      <strong>Gastrointestinal Perforation:</strong> Corticosteroid administration may
                                      increase risk of gastrointestinal perforation in patients with certain GI disorders
                                      and fresh intestinal anastomoses. Avoid corticosteroids in these patients.
                                  </li>
                                  <li>
                                      <strong>Alterations in Bone Density:</strong> Corticosteroids decrease bone formation
                                      and increase bone resorption. Special consideration should be given to
                                      patients with or at increased risk of osteoporosis prior to treatment.
                                  </li>
                                  <li>
                                      <strong>Behavior and Mood Disturbances:</strong> Corticosteroids may cause adverse
                                      psychiatric reactions. Prior to treatment, special consideration should be
                                      given to patients with previous or current emotional instability or psychiatric
                                      illness. Advise patients to immediately report any behavior or mood
                                      disturbances.
                                  </li>
                              </ul>

                              <h4 className="text-primary fw-medium">Adverse Reactions</h4>
                              <p className="text-black">
                                  Most commonly reported adverse reactions (incidence ≥1%) in clinical studies include
                                  sinusitis, cough, and contusions.
                              </p>

                              <h5 className="fw-medium">
                                  Full Prescribing Information available at{" "}
                                  <a href="https://www.zilrettalabel.com" target="_blank">
                                      www.ZILRETTALabel.com
                                  </a>
                              </h5>
                              <h5 className="fw-medium">
                                  Please see Instructions for Use at{" "}
                                  <a
                                      style={{color: "#13B5EA"}}
                                      href="https://www.ioverapro.com/instructions-for-use"
                                      target="_blank"
                                  >
                                      www.ioverapro.com/instructions-for-use
                                  </a>
                              </h5>

                              <p className="text-black">
                                  &copy;  2026 Pacira Pharmaceuticals, Inc., a wholly owned subsidiary of Pacira
                                  BioSciences, Inc.
                                  ZILRETTA and FlexForward are registered trademarks of Pacira Therapeutics, Inc., and
                                  iovera° is a
                                  registered trademark of Pacira CryoTech, Inc., both of which are wholly owned
                                  subsidiaries of
                                  Pacira BioSciences, Inc. All rights reserved. PP-MP-US-0346 08/26
                              </p>

                          </div>
                      </div>
                  </div>
              </footer>
          )}
      </>
  );
};

export default Footer;
